export default __webpack_public_path__ + "static/media/water.6f5ede85.jpg";